import React, { useEffect, useState } from 'react'
import "./MyAccount.css"
import Navbar from "../Navbar/Navbar"
import { Link } from 'react-router-dom'
//import { useSelector } from 'react-redux'
import useAuth from "../../../MiddleWay/useAuth"
import { useGetChildrenQuery } from '../../../Redux/Api/AuthApi'
import { useSelector } from 'react-redux'

const MyAccount = () => {
  const [childData,setChildData] = useState()
  const {auth_info} = useSelector((state)=>state?.Auth)
  const {id} = useAuth()
  
  const {data,isSuccess} = useGetChildrenQuery(id)

  useEffect(()=>{
    let dataMap = []
   if(isSuccess){
    dataMap.push(data)
    setChildData(dataMap)
   }
  },[isSuccess,setChildData,data])
  console.log(childData)
  const student = {
    "isStudent":"yes",
  }
  return (
    <div className='kiga-portal-myaccount-main'>
     <Navbar/>
     <div className='kiga-portal-myaccount-title'>
        <p>Accounts</p>
     </div>
     <section className='kiga-portal-myaccount-section'>
       <div className='kiga-portal-myaccount-section-links'>
        <a href='#students'>students</a>
        <a href="#payments">payments</a>
        <a href="#account">Account Information</a>
        <a href="#security">Login/Security</a>
       </div>
       <div className='kiga-portal-myaccount-section-back'>
         <div className='kiga-portal-myaccount-section-student-title' id='students'>
            <p>Your Childrens</p>
         </div>
         <div className='kiga-portal-myaccount-section-student-function-box-flex'>
          {
            childData?.map((el,index)=>(
         <div className='kiga-portal-myaccount-section-student-function-box' key={index}>
          <div className="kiga-portal-myaccount-section-student-function-badje">
             <p>{el?.childName?.slice(0,3)}</p>
          </div>

          <div className="kiga-portal-myaccount-section-student-function-form-name">
            <p>Ntuyenabo Abdallah</p>
          </div>
             <div className='kiga-portal-myaccount-section-student-function-form-grid'>

              <div className='kiga-portal-myaccount-section-student-function-form-enrollments'>
                <div className='kiga-portal-myaccount-section-student-function-form-enrollments-icon'>
                 <img src="/images/enrollments-icon.svg" alt='enrollment'/>
                </div>
               <Link to='/kiga/user/student-enroll'>Enrollments</Link>
              </div>

              <div className='kiga-portal-myaccount-section-student-function-form-future-absence'>
              <div className='kiga-portal-myaccount-section-student-function-form-future-absence-icon'>
               <img src="/images/absences.svg" alt='absence'/>
               </div>
               <Link to="/kiga/user/student-absence">future Absence</Link>
              </div>
         </div>
         </div>
            ))
          }
         </div>
         {
         childData?.length >= 0 ?(
         <div className='kiga-portal-myaccount-section-student-btn'>
           <Link to='/portal/booking/classes/add-student'>add student</Link>
         </div>
          ):(
          <div className='kiga-portal-myaccount-section-student-btn'>
           <Link to='/portal/booking/classes/add-student'>create students</Link>
         </div>
          )
         }
         
       </div>

       <div id='payments' className='kiga-portal-myaccount-section-back'>
         <div className='kiga-portal-myaccount-section-payment-title'>
           <p>Payments</p>
         </div>
         <div className='kiga-portal-myaccount-section-payment-method'>
           <div className='kiga-portal-myaccount-section-payment-method-mobile'>
             <div className='kiga-portal-myaccount-section-payment-method-mobile-number'>
                <p>RWF 0</p>
                <p>Mobile Money</p>
             </div>
             <div className='kiga-portal-myaccount-section-payment-method-mobile-btn'>
               <Link to={null}>Make Payment</Link>
             </div>
           </div>
          <div className='kiga-portal-myaccount-section-payment-method-credit'>
             <div className='kiga-portal-myaccount-section-payment-method-credit-number'>
                <p>RWF 0</p>
                <p>Credit Card</p>
             </div>
             <div className='kiga-portal-myaccount-section-payment-method-credit-btn'>
               <Link to={null}>Apply Credit</Link>
             </div>
           </div>
         </div>
       </div>

       <div id='account' className='kiga-portal-myaccount-section-back'>
        <div className='kiga-portal-myaccount-section-account-info-title'>
           <p>Account Information</p>
         </div>
         <div className='kiga-portal-myaccount-section-account-info-name'> 
          <p>{auth_info?.name}</p>
         </div>
         <div className='kiga-portal-myaccount-section-account-info-location'>
           <div className='kiga-portal-myaccount-section-account-info-location-icon'>
            <img src='/images/location.png' alt='location-svg'/>
           </div>
           <div className='kiga-portal-myaccount-section-account-info-location-info'>
             <p>kigali/rwanda</p>
             <p>kk345st</p>
           </div>
         </div>
         <div className='kiga-portal-myaccount-section-account-info-email'>
          <div className='kiga-portal-myaccount-section-account-info-email-icon'>
            <img src='/images/mail.png' alt='location-svg'/>
           </div>
           <div className='kiga-portal-myaccount-section-account-info-email-info'>
             <p>{auth_info?.email}</p>
             <p>father</p>
           </div>
         </div>
        <div className='kiga-portal-myaccount-section-account-info-call'>
          <div className='kiga-portal-myaccount-section-account-info-call-icon'>
            <img src='/images/telephone.png' alt='location-svg'/>
           </div>
           <div className='kiga-portal-myaccount-section-account-info-call-info'>
             <p>0877666</p>
             <p>father</p>
           </div>
         </div>
       </div>

       <div id='security' className='kiga-portal-myaccount-section-back'>
         <div className='kiga-portal-myaccount-section-account-security-title'>
            <p>Login/Security</p>
         </div>
         <div className='kiga-portal-myaccount-section-account-btn'>
           <Link to='/portal/dashboard/changePassword'>Change Password</Link>
         </div>
       </div>
     </section>
    </div> 
  )
}

export default MyAccount